import React, { useState, useEffect, useRef } from 'react';
import styles from './Header.module.css';
import LogoMain from '../../assets/images/logo.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const sections = [
  { id: 'inicio', label: 'Início' },
  { id: 'funciona', label: 'Como funciona' },
  { id: 'conteudos', label: 'Conteúdos' },
  { id: 'diferenciais', label: 'Diferenciais' }
];

const HEADER_HEIGHT = 78;

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');
  const ignoreHash = useRef(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (ignoreHash.current) return;
      let current = 'inicio';
      const scrollPosition = window.scrollY + HEADER_HEIGHT + 1;
      for (const section of sections) {
        const el = document.getElementById(section.id);
        if (el && el.offsetTop <= scrollPosition) {
          current = section.id;
        }
      }
      setActiveSection(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Faz scroll após voltar pra Home
  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => {
          window.scrollTo({
            top: el.offsetTop - HEADER_HEIGHT,
            behavior: 'smooth',
          });
        }, 100);
      }
    }
    // eslint-disable-next-line
  }, [location]);

  const handleMenuClick = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);

    if (location.pathname !== '/') {
      // Navega para Home e scrolla depois
      navigate('/', { state: { scrollTo: id } });
    } else {
      const el = document.getElementById(id);
      if (el) {
        ignoreHash.current = true;
        window.scrollTo({
          top: el.offsetTop - HEADER_HEIGHT,
          behavior: 'smooth'
        });
        setActiveSection(id);
        setTimeout(() => { ignoreHash.current = false; }, 700);
      }
    }
  };

  return (
    <header className={styles.headerMenu}>
      <div className={styles.containerMenu}>
        <Link to="/" onClick={() => window.scrollTo(0, 0)}>
          <img src={LogoMain} alt="Traily Logo" className={styles.logo} />
        </Link>
        <nav className={`${styles.nav} ${menuOpen ? styles.open : ''}`}>
          {sections.map(section => (
            <a
              key={section.id}
              href={`#${section.id}`}
              onClick={e => handleMenuClick(e, section.id)}
              className={activeSection === section.id ? styles.active : ''}
            >
              {section.label}
            </a>
          ))}
        </nav>
        <div className={styles.buttons}>
          <a
            href="https://tally.so/r/3qXVr9"
            className={styles.contactButton}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              if (typeof window.gtag_report_conversion === 'function') {
                window.gtag_report_conversion('https://tally.so/r/3qXVr9');
              }
            }}
          >
            Contato
          </a>

          <button
            className={styles.menuButton}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={24} color="black" /> : <Menu size={24} color="black" />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
